














import Component from "vue-class-component";
import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { updateGTMGlobalVariables } from "@/utils/gtm";

@Component
export default class NotFound extends BaseRootPageComponent {
  created() {
    this.setTitle("Page Not Found");

    // updateGTMGlobalVariables(this);
  }
}
